import {
  collection, deleteDoc, deleteField, doc, onSnapshot,
  query, serverTimestamp, setDoc, updateDoc,
} from 'firebase/firestore';
import { db } from '../../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../../config/Config';

const appId = FIREBASE_CONFIG.projectId;

const WORKSPACES_PATH = ['artifacts', appId, 'public', 'data', 'autos_workspaces'];
const CLIENTS_PATH = ['artifacts', appId, 'public', 'data', 'clients'];

function getWorkspacesCollectionRef() {
  return collection(db, ...WORKSPACES_PATH);
}

function getClientsCollectionRef() {
  return collection(db, ...CLIENTS_PATH);
}

/**
 * 1. Assina a coleção de workspaces em tempo real.
 */
export function subscribeWorkspaces(callback, onError) {
  const col = getWorkspacesCollectionRef();
  const q = query(col);
  return onSnapshot(q, callback, onError);
}

/**
 * 2. Atualiza (merge) os dados de Drive de um cliente.
 */
export async function updateClientDriveInfo(clientId, data) {
  const clientRef = doc(getClientsCollectionRef(), clientId);
  await setDoc(clientRef, data, { merge: true });
}

/**
 * 3. Atualiza (merge) um workspace existente.
 */
export async function updateWorkspace(workspaceId, data) {
  const workspaceRef = doc(getWorkspacesCollectionRef(), workspaceId);
  await setDoc(workspaceRef, data, { merge: true });
}

/**
 * 4. Limpa campos de Drive órfãos de um cliente (self-healing P76).
 */
export async function clearClientOrphanDriveFields(clientId) {
  const orphanRef = doc(getClientsCollectionRef(), clientId);
  await updateDoc(orphanRef, {
    driveFolderId: deleteField(),
    driveFolders: deleteField(),
    driveTreeVersion: deleteField(),
    driveTreeLastCheckedAt: deleteField(),
  }).catch(() => null);
}

/**
 * 5. Cria uma referência de documento para um novo workspace.
 */
export function createNewWorkspaceRef() {
  return doc(getWorkspacesCollectionRef());
}

/**
 * 6. Cria (merge) um novo workspace.
 */
export async function createWorkspace(workspaceRef, data) {
  await setDoc(workspaceRef, data, { merge: true });
}

/**
 * 7. Deleta um workspace pelo ID.
 */
export async function deleteWorkspace(workspaceId) {
  await deleteDoc(doc(getWorkspacesCollectionRef(), workspaceId));
}

/**
 * 8. Deleta múltiplos workspaces.
 */
export async function deleteWorkspaces(workspaceIds) {
  const col = getWorkspacesCollectionRef();
  await Promise.all(workspaceIds.map((id) => deleteDoc(doc(col, id))));
}

/**
 * 9. Vincula um workspace a um processo (atualiza ancestry).
 */
export async function linkWorkspaceToProcess(workspaceId, data) {
  const ref = doc(getWorkspacesCollectionRef(), workspaceId);
  await setDoc(ref, data, { merge: true });
}

/**
 * 10. Exporta serverTimestamp para uso no componente.
 */
export { serverTimestamp };
